import { Button, Form, Input, Radio, Space, Typography } from "antd";
import { PlusCircle, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";


export const ShortAnswerQuestion = () => {
  const {t} = useTranslation();
  return (
    <>
      <div style={{ marginBottom: 8 }}>
        <Typography.Text strong type="warning">
        {t("forms.questions.enterCorrectAnswer")}
        </Typography.Text>
      </div>

      <Form.List name={["answers"]} initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <Radio.Group style={{ width: "100%" }}>
            {fields.map(({ key, name, ...restField }) => {
              return (
                <Space
                  className="question-type-form"
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item
                    noStyle
                    initialValue={true}
                    {...restField}
                    name={[name, "isCorrect"]}
                    valuePropName="checked"
                  ></Form.Item>

                  <Form.Item
                    style={{ width: "100%" }}
                    {...restField}
                    name={[name, "value"]}
                    rules={[
                      { required: true, message: t("forms.questions.inputPlaceholder") },
                    ]}
                  >
                    <Input placeholder={t("forms.questions.inputPlaceholder")} />
                  </Form.Item>
                  <Button
                    icon={<Trash2 />}
                    danger
                    onClick={() => remove(name)}
                  />
                </Space>
              );
            })}
            <Form.Item noStyle>
              <Button
                type="dashed"
                icon={<PlusCircle />}
                block
                onClick={() => add()}
              >
                {t("forms.questions.addAnswer")}
              </Button>
            </Form.Item>
          </Radio.Group>
        )}
      </Form.List>
    </>
  );
};
